class VvCollectionDescription extends HTMLElement {
    MAX_LENGTH = 350;
    SHOW_MORE = true;
    constructor() {
      super();
      this.descriptionFull = this.innerHTML;
  
      if (this.getAttribute("show-more") === "false") {
        this.SHOW_MORE = false;
      }
  
      if (this.getAttribute("max-length")) {
        this.MAX_LENGTH = parseInt(this.getAttribute("max-length"));
      }
  
      if (this.innerText.length > this.MAX_LENGTH) {
        // truncate text
        this.descriptionClipped = window.textClipper(
          this.descriptionFull,
          this.MAX_LENGTH,
          {
            html: true,
            indicator: "..."
          }
        );
  
        // replace original content with cropped desc
        this.innerHTML = this.descriptionClipped;
  
        // remove processing class
        this.classList.remove("processing");
      }
    }
  }
  
  customElements.define("vv-collection-description", VvCollectionDescription);
  